module.exports = __webpack_public_path__ + "assets/lajiao.a42b6dcc.svg";